// extracted by mini-css-extract-plugin
export default {"container":"CardsPay_container__98Zj7","flex":"CardsPay_flex__c8Sis","box":"CardsPay_box__o+Rl7","imge":"CardsPay_imge__2+L0L","check":"CardsPay_check__nC7mQ"};